export function normalizeToScale(min: number, max: number, currentValue: number): number {
    const clampedValue = Math.max(min, Math.min(max, currentValue));
    return ((clampedValue - min) / (max - min)) * 100;
}